import BaseComponent from "../../BaseComponent";
import lottie from 'lottie-web';

export default class FlashOverlayModal extends BaseComponent {
    init(): void {
        const $visibleModals = $('.modal:visible');

        if ($visibleModals.length > 0) {
            // Another modal is visible — wait for it to close before showing this one
            $visibleModals.first().on('hidden.bs.modal', () => {
                this.$component.modal('show');
                this.initAnimations();
            });
        } else {
            this.$component.modal('show');
            this.initAnimations();
        }
    }

    private initAnimations(): void {
        this.$component.find('.lottie-animation').each((_index: number, element: HTMLElement) => {
            const path = element.dataset.animationPath;
            if (!path) {
                return;
            }

            lottie.loadAnimation({
                container: element,
                renderer: 'svg',
                loop: false,
                autoplay: true,
                path: path,
            });
        });
    }
}
